import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const meilisearch = defineConnector({
  identifier: "meilisearch",
  name: "Meilisearch",
  tagLine: "Search API for apps and websites",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Meilisearch API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Meilisearch Cloud dashboard](https://cloud.meilisearch.com/), select your project and navigate to **Settings > API Keys**. Copy your **Admin API Key** or a **Search API Key** depending on the access level you need.",
        },
      ],
    },
    {
      title: "Enter your Meilisearch details",
      items: [
        {
          kind: "baseUrl",
          label: "Meilisearch host URL",
          required: true,
          placeholder: "https://ms-abc123.sfo.meilisearch.io",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The URL of your Meilisearch instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/health`,
  },
});
